import { openDB, 
  // deleteDB 
} from 'idb';
import { 
  OFFLINE_DATABASE_NAME,
  USERS_STORE_NAME,
  UNSYNCED_USERS_STORE_NAME,
  UNSYNCED_JOBSITES_STORE_NAME,
  ROLES_STORE_NAME,
  REQUESTS_STORE_NAME,
  JOBSITES_STORE_NAME,
  JOBSITE_DETAILS_STORE_NAME,
  JOBSITE_ADDRESS_STORE_NAME,
  JOBSITE_WORKERS_STORE_NAME,
  JOBSITE_FILES_STORE_NAME,
  JOBSITE_TRADES_STORE_NAME,
  JOBSITE_SUBMIT_STORE_NAME,
  JOBSITE_MARK_AS_COMPLETE_STORE_NAME,
  CONTRACTORS_STORE_NAME,
  JOBSITE_COMMENTS_STORE_NAME,
  JOBSITE_DELETE_STORE_NAME,
  JOBSITE_FILES_DELETE_STORE_NAME
} from './dbConstants';

const STORES_CONFIG = [
  { name: USERS_STORE_NAME, keyPath: 'id' },
  { name: UNSYNCED_USERS_STORE_NAME, keyPath: 'id' },
  { name: UNSYNCED_JOBSITES_STORE_NAME, keyPath: 'id' },
  { name: ROLES_STORE_NAME, keyPath: 'id' },
  { name: REQUESTS_STORE_NAME, keyPath: 'url' },
  { name: JOBSITES_STORE_NAME, keyPath: 'url' },
  { name: JOBSITE_DETAILS_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_ADDRESS_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_WORKERS_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_FILES_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_TRADES_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_SUBMIT_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_MARK_AS_COMPLETE_STORE_NAME, keyPath: 'url' },
  { name: CONTRACTORS_STORE_NAME, keyPath: 'id' },
  { name: JOBSITE_COMMENTS_STORE_NAME, keyPath: 'id'},
  { name: JOBSITE_DELETE_STORE_NAME, keyPath: 'url'},
  { name: JOBSITE_FILES_DELETE_STORE_NAME, keyPath: 'url'}
];

export const dbVersion = 11;

export const initDB = async (customStoreName?: string, customKeyPath?: string) => {
  
  try {
    try {
      const testOpen = await openDB(OFFLINE_DATABASE_NAME, undefined, {
        blocking() { /* Handle blocking events */ }
      });
      testOpen.close();
    } catch (error) {
      console.error('Database does not exist yet or could not be opened:', error);
    }
    
    const db = await openDB(OFFLINE_DATABASE_NAME, dbVersion, {
      upgrade(db, oldVersion, newVersion) {
        
        
        for (const store of STORES_CONFIG) {
          if (!db.objectStoreNames.contains(store.name)) {
            try {
              db.createObjectStore(store.name, { keyPath: store.keyPath });
            } catch (error) {
              console.error(`Error creating store ${store.name}:`, error);
            }
          }
        }
        
        if (customStoreName && customKeyPath && !db.objectStoreNames.contains(customStoreName)) {
          try {
            db.createObjectStore(customStoreName, { keyPath: customKeyPath });
          } catch (error) {
            console.error(`Error creating custom store ${customStoreName}:`, error);
          }
        }
        
      },
      blocked() {
        console.warn('Database upgrade was blocked. Please close other tabs using this app.');
      },
      blocking() {
        console.warn('This connection is blocking a newer version of the database');
      },
      terminated() {
        console.error('Database connection was terminated unexpectedly');
      }
    });
    
    return db;
  } catch (error) {
    throw error;
  }
};

export const verifyDatabaseStores = async () => {
  try {
    const db = await openDB(OFFLINE_DATABASE_NAME);
    const existingStores = Array.from(db.objectStoreNames);
    
    const missingStores = STORES_CONFIG
      .map(store => store.name)
      .filter(name => !existingStores.includes(name));
    
    db.close();
    return { success: missingStores.length === 0, missingStores };
  } catch (error) {
    return { success: false, error };
  }
};
